import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Checkbox } from "@smartling-ui/checkbox";
import { Field } from "@smartling-ui/field";

import { LinkTermsAndConditions } from "../LinkTermsAndConditions";

import messages from "./messages";

type Props = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    onBlur?: () => void;
    error?: string;
}

export function AcceptTermsField({
    checked,
    onChange,
    onBlur,
    error
}: Props) {
    const intl = useIntl();

    const handleChange = useCallback(
        (value: boolean) => {
            onChange(value);
            onBlur?.();
        },
        [onChange, onBlur]
    );

    return (
        <Field.Root
            orientation="horizontal"
            invalid={!!error}
        >
            <Field.Control
                render={(
                    <Checkbox
                        checked={checked}
                        onChangeCallback={handleChange}
                        aria-label={intl.formatMessage(
                            messages.acceptPrivacyPolicyAriaLabel
                        )}
                    />
                )}
            />
            <Field.Content>
                <Field.Label>
                    {intl.formatMessage(
                        messages.acceptPrivacyPolicy,
                        {
                            link: <LinkTermsAndConditions />
                        }
                    )}
                </Field.Label>
                {error && (
                    <Field.Error>
                        {error}
                    </Field.Error>
                )}
            </Field.Content>
        </Field.Root>
    );
}
